import React, { useRef } from 'react';
import { Chip } from '@milanote/roma';

import TaskAssignmentPopupContent from '../../task/pills/assignment/TaskAssignmentPopupContent';
import ChipSelectionPopover from '../selectionViews/ChipSelectionPopover';
import { getChipClassNames } from './elementChipClassNames';
import type { ElementChipProps } from './elementChipTypes';

/**
 * Renders a task assignment pill and its generic selection-owned popover.
 */
const AssignmentChip: React.FC<Extract<ElementChipProps, { type: 'assignment' }>> = ({
    containerId,
    assigneeId,
    assigneeName,
    size,
    isSelected,
    isSearchHighlighted,
    onDeselect,
}) => {
    const tagRef = useRef<HTMLSpanElement | null>(null);
    const popupId = `task-assignment-${containerId}-${assigneeId}`;

    return (
        <>
            <Chip
                ref={tagRef}
                size={size}
                variant="user"
                className={getChipClassNames(isSelected, Boolean(isSearchHighlighted))}
            >
                @{assigneeName}
            </Chip>
            <ChipSelectionPopover
                triggerRef={tagRef}
                isOpen={isSelected}
                onOpenChange={(isOpen) => !isOpen && onDeselect?.()}
            >
                <TaskAssignmentPopupContent popupId={popupId} elementId={containerId} />
            </ChipSelectionPopover>
        </>
    );
};

export default AssignmentChip;
